import PubSub from "underpub-js";
import slick from "slick-carousel";

var PostInformation = function (options) {

  this.options = {
    $el: false,
    baseClass: 'mol-PostInformation',
  };

  $.extend(true, this.options, options);

};

PostInformation.prototype.init = function () {

  var self = this;

  self.$imagesCarousel = self.options.$el.find(`.${self.options.baseClass}__images__carousel`);
  self.$image = self.options.$el.find(`.${self.options.baseClass}__image`);
  self.$arrows = self.options.$el.find(`.${self.options.baseClass}__arrows`);
  self.$prevArrow = self.options.$el.find(`.${self.options.baseClass}__arrow--prev`);
  self.$nextArrow = self.options.$el.find(`.${self.options.baseClass}__arrow--next`);

  if (self.$image.length > 1) {
    self.$arrows.show();

    self.$imagesCarousel.slick({
      prevArrow: self.$prevArrow,
      nextArrow: self.$nextArrow,
      swipe: true,
    });
  }
};

export default PostInformation;